var EVENTS = {
  RESIZE: "resize",
  CHANGE: "change",
  OFF: "off",
  UPDATE: "update"
};
export { EVENTS };
